import React from "react";

const AKFilterOption = ({ keyFilter, dispatch }) => {
  const handleDispatch = () => {
    dispatch({
      type: "toggle",
      keyFilter: {
        header: keyFilter.header,
        key: keyFilter.key,
        filterOn: !keyFilter.filterOn,
      },
    });
  };
  return (
    <div className="pb-2 float-left col-sm-6">
      <div className="row">
        <div className="col"></div>
      </div>
      <div className="form-input-content-container row">
        <div className="col-sm-12">
          <div className="mt-0 pt-0 mb-0">
            <label className="font-weight-bold pl-1">{keyFilter.header}</label>
            <label className="ak-checkbox-label float-left">
              <input
                type="checkbox"
                checked={keyFilter.filterOn}
                onChange={handleDispatch}
              />
              <span className="ak-checkbox-custom rectangular"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AKFilterOption;
